module.exports = __webpack_public_path__ + "img/corriente_c_red.7ea97a60.svg";